import Layout from "./src/components/layout";
import PcPage from "./src/components/pc-page";
import { SiteConfigContext } from "./src/contexts/SiteConfigContext";
import { useAspecRatio } from "./src/hooks/useAspecRatio";
import React, { useEffect, useState } from "react";
import { PageProps, WrapPageElementBrowserArgs } from "gatsby";

import cardContent from "./src/images/checkin/cardContent.png";
import cardHeader from "./src/images/checkin/cardHeader.png";
import checkedBg from "./src/images/checkin/checkedBg.png";
import checkedTag from "./src/images/checkin/checkedTag.png";
import checkingBg from "./src/images/checkin/checkingBg.png";
import pendingBg from "./src/images/checkin/pendingBg.png";

import backIconLight from "./src/images/backIconLight.png";
import backIconDark from "./src/images/backIconDark.png";
import mainLogo from "./src/images/mainLogo.png";
import mobileBg from "./src/images/blurBg.jpg";
import pcPageBg from "./src/images/pcPageBg.jpg";
import qrcode from "./src/images/qrcode.png";

// home

import homeBg from "./src/images/home/bg.jpg";
import homeCheckIn from "./src/images/home/checkin.png";
import homeDownload from "./src/images/home/download.png";
import homeExchange from "./src/images/home/exchange.png";
import homeMinigame from "./src/images/home/minigame.png";
import homeShop from "./src/images/home/shop.png";
import homeShopClosed from "./src/images/home/shop_closed.png";

import gameAccountBg from "./src/images/pointShop/gameAccountBg.png";


import { useMotion } from "react-use";



export const wrapPageElement = ({
  element,
  props,
}: WrapPageElementBrowserArgs<any, any>) => {
   const images = [
     cardContent,
     cardHeader,
     checkedBg,
     checkedTag,
     checkingBg,
     pendingBg,
     mobileBg,
     backIconLight,
     mainLogo,
     pcPageBg,
     qrcode,
     homeBg,
     homeCheckIn,
     homeDownload,
     homeExchange,
     homeMinigame,
     homeShop,
     homeShopClosed,
     gameAccountBg,
   ];


  // 预加载部分图片
  useMotion(() => {
    images.forEach((image) => {
      const img = new Image();
      img.src = image;
    });
  });


  return <Layout {...props}>{element}</Layout>;
};

export const onInitialClientRender = () => {
  setTimeout(function () {
    document.getElementById("__loader").style.display = "none";
  }, 1000);
};
